import React from "react";

export default function Mensaje210396() {
  return (
    <>
      <p>
        <h6>21 DE MARZO DE 1996</h6>
        <br />
        <p>
          En este día tuve una visión de Jesús en oración. Es de noche y hay
          muchas estrellas en el Cielo. <br />
          Una voz me dice: ¡El, conoce a sus ovejas!. Entiendo esto con mi
          corazón. <br />
          El Señor conoce a todos y a cada uno, en tiempo y circunstancias de
          vida. <br />
          El buen Pastor es nuestra esperanza. EL nos busca, nos conoce y nos
          mira desde un tiempo de Eternidad. “Nos llama”. El que lo oye se
          acerca a su espíritu de Amor y El permanece en nosotros con su AMOR.{" "}
          <br />
          <br />
          ORACION <br />
          <br />
          Alma Salvadora de Jesucristo, consume mi alma hasta la última gota de
          deseo de mi misma y satisfácela con el ferviente deseo de Tú Amor por
          las almas. <br />
          Que las gotas de Tú Sangre Redentora caigan en mí corazón, lo
          transformen y arrebaten hacia tu Divino Corazón. <br />
          Amén.
        </p>
      </p>
    </>
  );
}
